import React, { useContext, useEffect, useMemo } from 'react';
import { toast } from 'sonner';

import { SubstitutionRuleEventsTable } from 'components/fbm/substitutions/SubstitutionRuleEventsTable';
import { UserContext } from 'contexts/UserContext';
import { useSubstitutionRuleEventsQuery } from 'shared/hooks/fbm/useSubstitutionRuleEventsQuery';

function ViewSubstitutionRuleEvents() {
    const { fbmAccount, user } = useContext(UserContext);
    const fbmAccountName = fbmAccount?.fbmAccountName;
    const facilityId = user?.facilityID;

    const { data, error, isFetching, isLoading } = useSubstitutionRuleEventsQuery({
        enabled: !!fbmAccount?.id,
        fbmAccountName,
        facilityId,
    });

    const rows = useMemo(() => data ?? [], [data]);

    useEffect(() => {
        if (error) {
            toast.error(`No substitution rule events found: ${error.message}`);
        }
    }, [error]);

    const title = fbmAccount?.companyName
        ? `${fbmAccount.companyName} - Substitution Rule Events`
        : 'Substitution Rule Events';

    if (!fbmAccountName) {
        return (
            <div className="mt-4">
                <h2 className="mb-4 text-lg font-semibold">{title}</h2>
                <p className="text-sm text-muted-foreground">
                    Please select an FBM account above to view substitution rule events.
                </p>
            </div>
        );
    }

    return (
        <div className="mt-4 flex flex-col">
            <h2 className="mb-4 text-lg font-semibold">{title}</h2>
            <SubstitutionRuleEventsTable data={rows} isLoading={isLoading} isFetching={isFetching} />
        </div>
    );
}

export { ViewSubstitutionRuleEvents };
